/* eslint-disable no-underscore-dangle */
import SearchClient from '../search';

export default class AgesconClient extends SearchClient {
  constructor(options = {}) {
    super(options);
  }

    updatePass = async (data) => {
      const { dni } = data;
      try {
        const response = await this.request('post')(
          { ...data },
          { path: `agescon/${ dni }` },
        );
        return response;
      } catch (error) {
        return error.response;
      }
    }
}
